export type LandingPageId = 'engineers' | 'recruiters' | 'vibecodes' | 'vibengineers'

export type RoutePath =
  | '/'
  | '/contact'
  | '/engineers'
  | '/resume'
  | '/recruiters'
  | '/service'
  | '/terms'
  | '/vibecodes'
  | '/vibengineers'

type RoutePathKey = 'contact' | 'home' | 'resume' | 'service' | 'terms' | LandingPageId

export const routePaths: Record<RoutePathKey, RoutePath> & Record<string, RoutePath> = {
  contact: '/contact',
  engineers: '/engineers',
  home: '/',
  recruiters: '/recruiters',
  resume: '/resume',
  service: '/service',
  terms: '/terms',
  vibecodes: '/vibecodes',
  vibengineers: '/vibengineers',
}

export const runtimeConfig = {
  bootStorageKey: 'hta.boot.complete',
  motionStorageKey: 'hta.motion.reduced',
  reducedMotionMediaQuery: '(prefers-reduced-motion: reduce)',
  skipTargetId: 'content',
} as const

export const emailLink = {
  href: 'mailto:vitaliy@hireanautist.com',
  label: 'Email',
  type: 'email',
} as const

export const externalLinks = [emailLink] as const
